import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import MaterialTable from "material-table";
import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import AddOutlinedIcon from "@material-ui/icons/AddOutlined";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DoneOutlinedIcon from "@material-ui/icons/DoneOutlined";
import ClearOutlinedIcon from "@material-ui/icons/ClearOutlined";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import NavigateNextOutlinedIcon from "@material-ui/icons/NavigateNextOutlined";
import NavigateBeforeOutlinedIcon from "@material-ui/icons/NavigateBeforeOutlined";
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import { Typography } from "@material-ui/core";
import AttachFileOutlinedIcon from "@material-ui/icons/AttachFileOutlined";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import { fetchCourseStudents,setCourseStudents } from "../firebaseApi";
const styles = (theme) => ({});

function StudentCourseDrop(props) {
  let { course } = props;
  let { studentID } = props;
  let [sessions, setSessions] = useState([]);
  let [votes, setVotes] = useState([]);
  let { tableData } = props;

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={props.open}
      onClose={() => {
        props.openCtl(false);
      }}
    >
      <DialogTitle>{"Drop " + props.course.courseName + "?"}</DialogTitle>

      <DialogContent>
        <DialogContentText>
          Do you really want to drop this class? This action is will remove this class from your courses. If you rejoin the class later, your votes will be saved.
        </DialogContentText>
      </DialogContent>

      <DialogActions>
      <Button
          color="primary"
          onClick={() => {
            props.openCtl(false);
          }}
        >
          Close
        </Button>
        <Button
          color="primary"
          onClick={() => {
            fetchCourseStudents({courseID:props.courseID}).then((data)=>{
              let stud = Object.keys(data);
              setCourseStudents({courseID: props.courseID,initialStudents:stud,students:stud.filter(item => item !== props.studentID)})
              props.hidePoll(props.courseID)
            })
            props.openCtl(false);
          }}
        >
          Drop Class
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(withWidth()(StudentCourseDrop))
  )
);
